__webpack_require__.p = "https://assets.simple.life/dev/static/develop/2c08ccb0/";